import * as React from "react";
import { SVGProps } from "react";

const Dash = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 416" {...props}>
    <defs>
      <style>{".cls-1{fill:#008de4}"}</style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          d="M336.25 0h-186.9l-15.5 86.6 168.7.2c83.1 0 107.6 30.2 106.9 80.2-.4 25.6-11.5 69-16.3 83.1-12.8 37.5-39.1 80.2-137.7 80.1l-164-.1L76 416.8h186.5c65.8 0 93.7-7.7 123.4-21.3 65.7-30.5 104.8-95.3 120.5-179.9C529.65 89.6 500.65 0 336.25 0"
          className="cls-1"
        />
        <path
          d="M68.7 164.9c-49 0-56 31.9-60.6 51.2C2 241.3 0 251.6 0 251.6h191.4c49 0 56-31.9 60.6-51.2 6.1-25.2 8.1-35.5 8.1-35.5Z"
          className="cls-1"
        />
      </g>
    </g>
  </svg>
);

export default Dash;
